import { COMMON_TEXT } from "@/constants/text";
import { getPrinterCodeByUserWithWhoami } from "@/utils/checkAuth";
import { customNotification } from "@/utils/notificationShow";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

interface useBarcodePrintHandlerProps {
  lotName: string[] | undefined;
  itemCode: string[] | undefined;
  locationCode: string[] | undefined;
}

export const useBarcodePrintHandler = ({
  lotName,
  locationCode,
  itemCode,
}: useBarcodePrintHandlerProps) => {
  const mutation = useMutation({
    mutationFn: async () => {
      return await axios.post(
        `${process.env.REACT_APP_COMPANY_BARCODE_ADDRESS_INVENTORY}`,
        {
          company_code: process.env.REACT_APP_COMPANY_CODE,
          lot_name: lotName,
          printer_code: await getPrinterCodeByUserWithWhoami(),
          quantity: 1,
          location_code: locationCode,
          item_code: itemCode,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    },
    onSuccess: () => {
      customNotification.success({
        message: COMMON_TEXT.NOTIFICATION.BARCODE_PRINT_SUCCESS,
      });
    },
    onError: (error: any) => {
      customNotification.error({
        message: error ?? COMMON_TEXT.NOTIFICATION.BARCODE_PRINT_FAIL,
      });
    },
  });

  return {
    onSubmit: mutation.mutateAsync, // 기존 onSubmit 대신 mutateAsync 사용
  };
};
